/**
 * Native app identifiers (aligned with Expo `app.json` / store listings).
 * Used for Smart App Banner, App Links meta (`al:*`), and related head tags.
 */
export const NATIVE_APP = {
  scheme: 'clubedotennis',
  /** Canonical marketing host used in universal links and email URLs. */
  webHost: 'www.clubedotennis.com.br',
  appStoreId: '6747998672',
  androidPackage: 'br.com.clubedotennis.app',
  displayName: 'Clube do Tennis',
} as const

/** Custom-scheme base URL mirroring Enjoei’s `al:ios:url` / `al:android:url` pattern. */
export function nativeAppLinkBaseUrl() {
  return `${NATIVE_APP.scheme}://${NATIVE_APP.webHost}/`
}
